import React, {useState, useEffect} from "react"
import styled from "styled-components"
import BtnCompo from "../../SubComponents/Btn"
import Solo from "./Solo"
import Duo from "./Duo/Duo"
const Styled = {
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    SituationBtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
    BtnWrap:styled.div`
        width:120px;
        height:45px;
        background-color:gold;
        border-radius: 10px;
        display:flex;
        justify-content: center;
        flex-direction:row;
        align-items: center;
        :hover{
            opacity:50%;
        }
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,

}
interface PropsType {
    Points : number;
    setPoints : any;
}
const SoloOrDuo=(props:PropsType)=>{
    // const [Question, setQuestion] = useState<any>([
    //     ""
    // ])
    const Points = props.Points;
    const setPoints = props.setPoints
    const [Solo_Duo, setSolo_Duo] = useState<number>(0)
    const [Page, setPage] = useState<number>(0)
    
    if(Solo_Duo === 0){
        return(
            <Styled.Wrap>
               <Styled.LittleTitleFont>
                   한부모 가정인가요??
               </Styled.LittleTitleFont>
               <Styled.SituationBtnWrap>
                    {/* {AnswerList.map((v:any)=>{
                        const Text:any = Object.values(v)[0]
                        const Answer:any = Object.values(v)[1]
                        return(
                            <BtnCompo 
                                content={Text}
                                PageNumber={Answer}
                                Page={Page}
                                setPage={setPage}
                            />
                        )
                    })} */}
                    <Styled.BtnWrap onClick={()=>{setSolo_Duo(1)}}>
                        <Styled.Fonts>맞아요</Styled.Fonts>
                    </Styled.BtnWrap>
                    <Styled.BtnWrap onClick={()=>{setSolo_Duo(2)}}>
                        <Styled.Fonts>아니에요</Styled.Fonts>
                    </Styled.BtnWrap>
               </Styled.SituationBtnWrap>
            </Styled.Wrap>
           )
    }else if(Solo_Duo === 1){
        //한부모
        return(
            <Solo 
                Points={Points}
                setPoints={setPoints}
                Solo_Duo={Solo_Duo}
                setSolo_Duo={setSolo_Duo}
            />
        )
    }else if(Solo_Duo === 2){
        //듀오
        return(
            <Duo 
                Points={Points}
                setPoints={setPoints}
                Solo_Duo={Solo_Duo}
                setSolo_Duo={setSolo_Duo}
            />
        )
    }else{
        return(
            <div>error</div>
        )
    }
    
}

export default SoloOrDuo